"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialistNotEffectiveConstants = exports.notEffectiveConstants = exports.CancelDestinations = exports.notEffectiveFinalDestinations = exports.effectiveFinalDestinations = exports.finalDestinationsArray = void 0;
/** @warning CUIDADO MAYúSCUlaS Y MiNuSCuLaS PuEdEn EsTaR MaL; VaMoS A EsTaR CHeQUeANdO Y ReVISaNdO EsO, usar con precaución */
exports.finalDestinationsArray = [
    "Anula el paciente",
    "Anula por falla de conexión",
    "En domicilio con instrucciones",
    "En domicilio con monitoreo",
    "En domicilio con seguimiento",
    "Envía Médico a Domicilio",
    "Evaluación en amarillo VMD",
    "Evaluación en amarillo",
    "Evaluación en rojo",
    "Evaluación en verde VMD",
    "Indico concurrir a guardia externa",
    "Indico seguimiento con especialista",
    "Indico seguimiento por consultorio externo",
    "Paciente ausente",
    "Solicito Médico para visita a domicilio",
    "Traslado protocolo pandemia",
    "USER CANCEL",
    "PROVIDER CANCEL",
    "DELAY CANCEL",
    "PORTAL CANCEL"
];
/** @warning CUIDADO MAYúSCUlaS Y MiNuSCuLaS PuEdEn EsTaR MaL; VaMoS A EsTaR CHeQUeANdO Y ReVISaNdO EsO, usar con precaución */
exports.effectiveFinalDestinations = [
    "En domicilio con instrucciones",
    "Evaluación en verde VMD",
    "Evaluación en amarillo",
    "Evaluación en rojo",
    "Indico seguimiento por consultorio externo",
    "Indico seguimiento con especialista",
    "Indico concurrir a guardia externa",
    "En domicilio con monitoreo",
    "Traslado protocolo pandemia",
    "Requiere atención de guardia presencial"
];
/** @warning CUIDADO MAYúSCUlaS Y MiNuSCuLaS PuEdEn EsTaR MaL; VaMoS A EsTaR CHeQUeANdO Y ReVISaNdO EsO, usar con precaución */
exports.notEffectiveFinalDestinations = [
    "Anula el paciente",
    "Anula por falla de conexión",
    "Paciente ausente",
    "USER CANCEL",
    "PROVIDER CANCEL",
    "AUTOMATIC_CANCEL",
    "CANCEL",
    "DELAY CANCEL",
    "PORTAL CANCEL"
];
exports.CancelDestinations = [
    "CANCEL",
    "USER CANCEL",
    "AUTOMATIC_CANCEL",
    "DELAY CANCEL"
];
exports.notEffectiveConstants = [
    "Anula el paciente",
    "Anula por falla de conexión",
    "Paciente ausente",
    "USER CANCEL",
    "AUTOMATIC_CANCEL",
    "",
    null
];
exports.specialistNotEffectiveConstants = [
    "Anula el paciente",
    "Anula por falla de conexión",
    "Paciente ausente",
    "USER CANCEL",
    "AUTOMATIC_CANCEL",
];
